import {useApiariesStore} from 'entities/apiaries'; // если стор используется
import {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {pluralizeHive} from 'shared/helpers/pluralizeApiary';
import {ApiaryWithHiveCount} from 'widgets/apiariesModal/types';
import {ApiariesCont, Apiary, ApiaryTextCont, ApiaryTitle, HiveCount} from './Apiaries.styles';

type Props = {
  apiaries: ApiaryWithHiveCount[];
};

export const Apiaries: FC<Props> = ({apiaries}) => {
  const currentApiary = useApiariesStore((s) => s.currentApiary());
  const setCurrentApiary = useApiariesStore((s) => s.setCurrentApiary);
  const navigate = useNavigate();

  if (!apiaries.length) return null;

  return (
    <ApiariesCont $noBorder>
      {apiaries.map((el) => {
        const isActive = el.id === currentApiary?.id;
        const name = el.name?.trim() !== '' ? el.name : 'Без названия';
        return (
          <Apiary
            key={el.id}
            $active={isActive}
            onClick={() => {
              setCurrentApiary(el.id);
              navigate('/');
            }}
          >
            {/* <ApiaryIcon fill={isActive ?
                            COLORS.ACCENT.DEFAULT
                            : undefined
                        }/> */}
            <ApiaryTextCont>
              <div>
                <ApiaryTitle>{name}</ApiaryTitle>
              </div>
              <HiveCount>
                {el.hiveCount} {pluralizeHive(el.hiveCount)}{' '}
              </HiveCount>
            </ApiaryTextCont>
          </Apiary>
        );
      })}
    </ApiariesCont>
  );
};
